<mat-card
    appearance="outlined"
    class="publication-work-panel"
>
    <mat-card-content>
        <button
            mat-raised-button
            (click)="openPublicationPage()"
        >
            <mat-icon>add_circle</mat-icon>
            Dodaj nową publikację
        </button>
        <mat-form-field>
            <mat-label>Wyszukaj publikację</mat-label>
            <input
                matInput
                [formControl]="searchTerm"
                placeholder="Wpisz nazwę publikacji"
            />
            <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
    </mat-card-content>
</mat-card>

@if (filteredPublications$ | async; as filteredPublications) {
    @if (filteredPublications.length === 0) {
        <div class="no-result">Brak wyników wyszukiwania</div>
    } @else {
        @if (publicationNames$ | async; as names) {
            <div class="publication-grid">
                @for (pub of filteredPublications; track pub.id) {
                    <gwo-publication-tile
                        [publication]="pub"
                        [existingNames]="names"
                    />
                }
            </div>
        }
    }
}
